import axios from 'axios';

export default {
    async getCouriers() {
        return axios.get('api/courierinfos');
    },
    async createCourier(dataParams) {
        return axios.post(`api/courierinfos`, dataParams);
    },
    async getCourier(courierinfoId) {
        return axios.get(`api/courierinfos/${courierinfoId}`);
    },
    async updateCourier(courierinfoId, dataParams) {
        return axios.put(`api/courierinfos/${courierinfoId}`, dataParams);
    },
    async deleteCourier(courierinfoId) {
        return axios.delete(`api/courierinfos/${courierinfoId}`);
    },
    async getMiscDetails(courierinfoId, date) {
        return axios.get(`api/courierinfos/${courierinfoId}/misc-details`, {
            params: {
                date: date
            }
        });
    }
};
